// extracted by mini-css-extract-plugin
export var title = "secondaryHero-module--title--3qayv";
export var subtitle = "secondaryHero-module--subtitle--Ftp5j";